import { t } from 'i18next'
import { Location } from '@/models/generated/graphql'
import AddOperatorTableActions from './AddOperatorTableActions'
import AddOperatorTableDataRow from './AddOperatorTableDataRow'
import CertificateInquiryStatus from '@/models/enums/CertificateInquiryStatus'

const action = (actions: AddOperatorTableActions, row: AddOperatorTableDataRow): JSX.Element => {
  if (row.actions === CertificateInquiryStatus.Accepted || row.actions === CertificateInquiryStatus.Requested) {
    return (<a onClick={() => actions.handleOnClickCancelInviteAction(row.id)}>{t('certificates.inquiry.addSupplier.table.data.actions.cancelInvitation')}</a>)
  } else {
    return (<a onClick={() => actions.handleOnClickInviteAction(row.requestedOperatorId)}>{t('certificates.inquiry.addSupplier.table.data.actions.invite')}</a>)
  }
}

export const getAddSupplierTableColumns = (actions: AddOperatorTableActions): any => {
  return [
    {
      key: 'name',
      title: t('certificates.inquiry.addSupplier.table.columns.name'),
      dataIndex: 'name',
      render: (x: string) => x,
      width: 285,
      ellipsis: true,
      sorter: true
    }, {
      key: 'skalNumber',
      title: t('certificates.inquiry.addSupplier.table.columns.skalNumber'),
      dataIndex: 'skalNumber',
      width: 135,
      sorter: true
    }, {
      key: 'primaryLocation',
      title: t('certificates.inquiry.addSupplier.table.columns.primaryLocation'),
      dataIndex: 'primaryLocation',
      render: (x: Location) => `${x?.street ?? ''} ${x?.houseNumber ?? ''}, ${x?.postalCode as string ?? ''}, ${x?.city ?? ''}`,
      width: 200,
      ellipsis: { showTitle: true }
    }, {
      key: 'actions',
      title: t('certificates.inquiry.addSupplier.table.columns.actions'),
      dataIndex: 'actions',
      render: (x: CertificateInquiryStatus, row: AddOperatorTableDataRow) => action(actions, row),
      width: 200
    }
  ]
}
